document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    document.addEventListener('click', function (event) {
        const syncBtn = event.target.closest('.zwssgr-sync-now-sync');

        if (!syncBtn) return;

        event.preventDefault();

        const zwssgrGmbEmail = syncBtn.getAttribute('zwssgr-gmb-email');

        if (!zwssgrGmbEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(zwssgrGmbEmail)) {
            //console.error('Sync Error: Invalid or missing GMB email');
            return;
        }

        if (syncBtn.disabled) {
            // console.log('Sync already in progress');
            return;
        }

        // Store original button text and disable the button
        const originalBtnText = syncBtn.textContent;
        syncBtn.disabled = true;
        syncBtn.innerHTML = '<span class="zwssgr-syn-spinner"></span> Syncing...';
        
        // Get the sync wrapper
        const syncWrapper = syncBtn.closest('.zwssgr-sync-wrapper-sync');
        
        // Create status message element if it doesn't exist
        let statusMessage = syncWrapper.querySelector('.zwssgr-sync-status');
        if (!statusMessage) {
            statusMessage = document.createElement('div');
            statusMessage.className = 'zwssgr-sync-status';
            syncWrapper.appendChild(statusMessage);
        }
        
        // Show initial status
        statusMessage.textContent = 'Starting sync process...';
        statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-loading';

        // First AJAX to trigger sync
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: new URLSearchParams({
                action: 'zwssgr_sync_now',
                zwssgrGmbEmail: zwssgrGmbEmail  
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // console.log(data.data.message || 'Sync done');
            } else {
                //console.error('Sync Error:', data.data.message || 'Sync error');
                syncBtn.disabled = false;
                syncBtn.innerHTML = originalBtnText;
                statusMessage.textContent = 'Error: ' + (data.data.message || 'Sync error');
                statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-error';
                setTimeout(() => {
                    window.location.reload();
                }, 150);
            }

            // Now trigger the email settings sync after the sync is done
            return fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'sync_zwssgr_email_settings',
                    zwssgrGmbEmail: zwssgrGmbEmail
                })
            });
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // console.log('Email settings configured successfully');
            } else {
                //console.error('Failed to configure email settings:', data.data.message);
                //syncBtn.disabled = false;
                //syncBtn.innerHTML = originalBtnText;
                //statusMessage.textContent = 'Error: ' + (data.data.message || 'Failed to configure email settings');
                //statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-error';
            }
        })
        .catch(error => {
            //console.error('Sync Error:', error.message);
            syncBtn.disabled = false;
            syncBtn.innerHTML = originalBtnText;
            statusMessage.textContent = 'Error: ' + error.message;
            statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-error';
        });

        // Start checking sync status
        let statusInterval = null;
        const checkSyncStatus = () => {
            fetch(ajaxurl + '?action=zwssgr_check_sync_status')
                .then(res => res.json())
                .then(data => {
                    const status = data?.data?.status || '';
                    if (status === '') {
                        // When status is empty, sync is in progress
                        syncBtn.disabled = true; // Ensure button stays disabled
                        syncBtn.innerHTML = '<span class="zwssgr-syn-spinner"></span> Syncing...'; // Show loading image
                        statusMessage.textContent = 'Syncing in progress...';
                        statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-loading';
                    } else if (status === 'zwssger_sync_enabled') {
                        // When status is zwssger_sync_enabled, sync is complete
                        syncBtn.disabled = false; // Re-enable the button
                        syncBtn.innerHTML = originalBtnText; // Remove loading image
                        statusMessage.textContent = 'Sync completed.';
                        statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-success';
                        clearInterval(statusInterval);
                        
                        // Hide success message after 5 seconds
                        setTimeout(() => {
                            statusMessage.textContent = '';
                            statusMessage.className = 'zwssgr-sync-status';
                        }, 5000);
                    }
                })
                .catch(err => {
                    //console.error('Error checking sync status:', err);
                    syncBtn.disabled = false;
                    syncBtn.innerHTML = originalBtnText;
                    statusMessage.textContent = 'Error checking sync status. Please try again.';
                    statusMessage.className = 'zwssgr-sync-status zwssgr-sync-status-error';
                    clearInterval(statusInterval);
                });
        };

        // Polling every 3 seconds to check sync status
        statusInterval = setInterval(checkSyncStatus, 4000);
    });
});
